import { useEffect, useState } from "react";

function useScrollAnimation(animationDuration = 1000, targetPosition = 0) {
	const [startPosition, setStartPosition] = useState(targetPosition);
	const [isAnimating, setIsAnimating] = useState(false);

	useEffect(() => {
		const distanceToScroll = targetPosition - startPosition;
		let startTime;

		function step(timestamp) {
			if (!startTime) {
				startTime = timestamp;
			}

			const progress = Math.min(
				(timestamp - startTime) / animationDuration,
				1
			);
			const newPosition = startPosition + distanceToScroll * progress;
			window.scrollTo(0, newPosition);

			if (progress < 1) {
				requestAnimationFrame(step);
			} else {
				setIsAnimating(false);
			}
		}

		if (isAnimating && animationDuration > 0) {
			requestAnimationFrame(step);
		}
	}, [animationDuration, startPosition, targetPosition, isAnimating]);

	const startScrollAnimation = () => {
		if (!isAnimating) {
			setStartPosition(window.scrollY);
			setIsAnimating(true);
		}
	};

	return startScrollAnimation;
}

export default useScrollAnimation;
